import { type Table } from '@tanstack/react-table'
import { Search } from 'lucide-react'
import React from 'react'

import { TextInput } from 'slab'

import { cn } from '../../../utils'

export const TableSearchSingleColumn = <T, >({
  table,
  columnId,
  placeholder,
  containerClassName,
  inputClassName,
  onChange,
}: {
  table: Table<T>;
  columnId: string;
  placeholder: string;
  containerClassName?: string;
  inputClassName?: string;
  onChange?: React.Dispatch<React.SetStateAction<string>>
}) => {
  return (
    <div className={cn('w-full', containerClassName)}>
      <TextInput
        data-testid={`single-column-search-${columnId}`}
        placeholder={placeholder}
        onChange={(event) => {
          if (onChange) {
            onChange(event.target.value)
          } else {
            table.getColumn(columnId)?.setFilterValue(event.target.value)
          }
        }}
        leadingIcon={Search}
        className={inputClassName}
      />
    </div>
  )
}
